import { createGlobalStyle } from 'styled-components';

export const theme = {
  colors: {
    pause: '#F54464',
    disabled_pause: '#F54464',
    error: '#EE1D52',
    active_red: '#2E2C4899',
    inactive_red: '#2E2C4838',
    active_blue: '#5278F7',
    inactive_blue: '#5278F766',
    white: '#fff',
    shadow_primary: '#29171740',
    shadow_secondary: '#7B7B7B40',
    button_primary: '#53555F',
    button_secondary: '#E23353',
    font_dark: '#171717',
    font_light: '#171717B2',
    header: '#B0B0ED',
    modal_background: '#4F494957',
    active_accordion: '#EDECF2',
    line: '#17171726',
    textfield_enabled: '#A39EBF',
    toggle_bgrd_active: '#2441C7',
    toggle_bgrd: '#777777',
    timer_title: 'rgba(46, 44, 72, 0.5)',
    timer_title_active: '#D3D3D3',
  },
  content: {
    max_width: '1440px',
  },
};

export default createGlobalStyle`
  html {
      min-height: 100vh;
      min-width: 100vw;
  }
  * {
    margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    font-weight: 400;
    color: ${theme.colors.white};
    text-align: left;
    
    * {
      padding: 0;
      margin: 0;
      border: 0;
    }


    *,
    *::before,
    *::after {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    :focus, :active {
      outline: none;
    }

    a {
      color: ${theme.colors.white};
    }
    
    a:focus, a:active {
      outline: none;
    }

    nav, footer, header, aside {
      display: block;
    }

    html, body {
      height: 100%;
      width: 100%;
      line-height: 1;
      font-size: 14px;
      -ms-text-size-adjust: 100%;
      -webkit-text-size-adjust: 100%;
      background-color: ${theme.colors.white};
    }

    input, button, textarea {
      font-family: inherit;
    }

    input::-ms-clear {
      display: none;
    }

    button {
      cursor: pointer;
    }

    a, a:visited {
      text-decoration: none;
    }

    a:hover {
      text-decoration: none;
    }

    ul li {
      list-style: none;
    }

    img {
      vertical-align: top;
    }

    * {
      font-family: 'Roboto', sans-serif;
    }

    h1, h2, h3, h4, h5, h6 {
      font-size: inherit;
      font-weight: 400;
    }
  }

  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
`;
